import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import axios from 'axios'
import CheckPermission from '../../common/Permissions/CheckPermission.js'
class TripAddEdit extends React.Component {
  state = {
    is_saving: false,
    action: 'add',
    pickup_data: [],
    destination_data: [],
    formData: {
      id: null,
      name_en: '',
      name_ar: '',
      pickup_id: '',
      destination_id: '',
      order: '1',
      image: null,
      meta_title_en: '',
      meta_title_ar: '',
      meta_desc_en: '',
      meta_desc_ar: '',
      meta_keywords_en: '',
      meta_keywords_ar: '',
      h1_ar: '',
      h1_en: '',
      h2_ar: '',
      h2_en: '',
    },
  }

  componentDidMount() {
    if (this.props.match && this.props.match.params) {
      this.setState(
        {
          action: this.props.match.params.action,
          formData: {
            ...this.state.formData,
            id: this.props.match.params.id,
          },
        },
        () => {
          if (this.state.action === 'edit' && this.state.formData.id) {
            this.loadTripData(this.state.formData.id)
          }
        }
      )
    }

    this.loadOtherData()
  }

  loadOtherData = async () => {
    var headers = {
      Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
      country_short_name: `${localStorage.getItem('countryShortName')}`,
    }

    var destinationData = await axios.get(Constant.getAPI() + '/admin/list-destinations', { headers })

    var pickupData = await axios.get(Constant.getAPI() + '/admin/pick-up-listing', { headers })

    if (destinationData.data?.success) {
      this.setState({
        destination_data: destinationData.data?.data || [],
      })
    }
    if (pickupData.data?.success) {
      this.setState({
        pickup_data: pickupData.data?.data || [],
      })
    }
  }

  loadTripData = async (id) => {
    await axios
      .get(Constant.getAPI() + '/admin/trip/' + id, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            formData: {
              ...res.data.data,
            },
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChange = ({ target: { name, value } }) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [name]: value,
      },
    })
  }

  handleChangeImage = ({ target: { name, files } }) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [name]: files[0],
      },
    })
  }

  onClear = () => {
    this.setState(
      {
        is_saving: false,
        formData: {
          id: this.state.formData.id || null,
          name_en: '',
          name_ar: '',
          destination_id: '',
          pickup_id: '',
          order: '1',
          image: null,
        },
      },
      () => {
        this.image_input.value = null
      }
    )
  }

  onSave = () => {
    this.setState({ is_saving: true })

    const formData = new FormData()
    formData.append('name_en', this.state.formData.name_en)
    formData.append('name_ar', this.state.formData.name_ar)
    formData.append('destination_id', this.state.formData.destination_id)
    formData.append('pickup_id', this.state.formData.pickup_id)
    formData.append('order', this.state.formData.order)

    formData.append('meta_title_en', this.state.formData.meta_title_en)
    formData.append('meta_title_ar', this.state.formData.meta_title_ar)
    formData.append('meta_desc_en', this.state.formData.meta_desc_en)
    formData.append('meta_desc_ar', this.state.formData.meta_desc_ar)
    formData.append('meta_keywords_en', this.state.formData.meta_keywords_en)
    formData.append('meta_keywords_ar', this.state.formData.meta_keywords_ar)
    formData.append('h1_ar', this.state.formData.h1_ar)
    formData.append('h1_en', this.state.formData.h1_en)
    formData.append('h2_ar', this.state.formData.h2_ar)
    formData.append('h2_en', this.state.formData.h2_en)

    if (this.state.formData.image && typeof this.state.formData.image == 'object') {
      formData.append('image', this.state.formData.image)
    }

    var request
    if (this.state.action === 'add') {
      request = axios.post(Constant.getAPI() + '/admin/trip', formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
    } else {
      request = axios.put(Constant.getAPI() + '/admin/trip/' + this.state.formData.id, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
    }

    request
      .then((data) => {
        if (data.status === 200 && data.data) {
          Swal.fire({
            title: this.state.action === 'add' ? 'Successfully created.' : 'Successfully updated.',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
          window.location.href = `#/trips`
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          is_saving: false,
        })
      })
  }

  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>Trip {this.state.action === 'edit' ? ' Edit' : ' Add'}</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="feather icon-home"></i>{' '}
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to={`/trips`}> Trips List</Link>
                    </li>
                    <li className="breadcrumb-item active">Trip {this.state.action === 'edit' ? ' Edit' : ' Add'}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-md-5 col-form-label">Name English</label>
                          <div className="col-md-7">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Name English"
                              value={this.state.formData.name_en}
                              name="name_en"
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-md-5 col-form-label">Name Arabic</label>
                          <div className="col-md-7">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Name Arabic"
                              value={this.state.formData.name_ar}
                              name="name_ar"
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-md-5 col-form-label">Pickup Location</label>
                          <div className="col-md-7">
                            <select
                              value={this.state.formData.pickup_id}
                              name="pickup_id"
                              onChange={this.handleChange}
                              className="form-control"
                            >
                              <option value="">Select</option>
                              {this.state.pickup_data.map(
                                (item) =>
                                  item.is_active && (
                                    <option value={item.id}>
                                      {item.pickup_address_en} / {item.pickup_address_ar}
                                    </option>
                                  )
                              )}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-md-5 col-form-label">Destination Location</label>
                          <div className="col-md-7">
                            <select
                              value={this.state.formData.destination_id}
                              name="destination_id"
                              onChange={this.handleChange}
                              className="form-control"
                            >
                              <option value="">Select</option>
                              {this.state.destination_data.map(
                                (item) =>
                                  item.is_active && (
                                    <option value={item.id}>
                                      {item.destination_address_en} / {item.destination_address_ar}
                                    </option>
                                  )
                              )}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="row">
                          <div className="col-sm-5">Image</div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <div>
                                <input
                                  type="file"
                                  id="img"
                                  name="image"
                                  accept="image/*"
                                  className="w-100"
                                  onChange={this.handleChangeImage}
                                  ref={(ref) => (this.image_input = ref)}
                                />
                              </div>
                            </div>
                            {this.state.formData && this.state.formData.image ? (
                              typeof this.state.formData.image == 'object' ? (
                                <img
                                  width="200px"
                                  height="150px"
                                  src={URL.createObjectURL(this.state.formData.image)}
                                  alt="img"
                                  onError={({ currentTarget }) => {
                                    currentTarget.src = './assets/images/no_image.png'
                                  }}
                                />
                              ) : (
                                <img
                                  width="200px"
                                  height="150px"
                                  src={Constant.getImage() + this.state.formData.image}
                                  alt="img"
                                  onError={({ currentTarget }) => {
                                    currentTarget.src = './assets/images/no_image.png'
                                  }}
                                />
                              )
                            ) : (
                              <img
                                width="200px"
                                height="150px"
                                src="./assets/images/no_image.png"
                                alt="img"
                              />
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-md-5 col-form-label">Order No.</label>
                          <div className="col-md-7">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Order No."
                              value={this.state.formData.order}
                              name="order"
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <CheckPermission permission={'manage-meta-tags'}>
                        <div
                          className="col-md-12"
                          style={{ borderTop: '2px solid #eee', marginBottom: 20, marginTop: 20 }}
                        ></div>
                        <h5 style={{ marginBottom: 23, marginLeft: 13, fontWeight: 'bold', fontSize: 18 }}>
                          Meta Settings
                        </h5>
                        <div className="col-md-6"></div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-5 col-form-label">Meta Title: English</label>
                            <div className="col-md-7">
                              <input
                                type="text"
                                className="form-control"
                                name="meta_title_en"
                                id="meta_title_en"
                                placeholder="Meta Title: English"
                                onChange={this.handleChange}
                                value={this.state.formData.meta_title_en}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-5 col-form-label">Meta Title: Arabic</label>
                            <div className="col-md-7">
                              <input
                                type="text"
                                className="form-control"
                                name="meta_title_ar"
                                id="meta_title_ar"
                                placeholder="Meta Title: Arabic"
                                onChange={this.handleChange}
                                value={this.state.formData.meta_title_ar}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-5 col-form-label">Meta Keywords: English</label>
                            <div className="col-md-7">
                              <input
                                type="text"
                                className="form-control"
                                name="meta_keywords_en"
                                id="meta_keywords_en"
                                placeholder="Meta Keywords: English"
                                onChange={this.handleChange}
                                value={this.state.formData.meta_keywords_en}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-5 col-form-label">Meta Keywords: Arabic</label>
                            <div className="col-md-7">
                              <input
                                type="text"
                                className="form-control"
                                name="meta_keywords_ar"
                                id="meta_keywords_ar"
                                placeholder="Meta Keywords: Arabic"
                                onChange={this.handleChange}
                                value={this.state.formData.meta_keywords_ar}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-5 col-form-label">Meta Description: English</label>
                            <div className="col-md-7">
                              <input
                                type="text"
                                className="form-control"
                                name="meta_desc_en"
                                id="meta_desc_en"
                                placeholder="Meta Description: English"
                                onChange={this.handleChange}
                                value={this.state.formData.meta_desc_en}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-5 col-form-label">Meta Description: Arabic</label>
                            <div className="col-md-7">
                              <input
                                type="text"
                                className="form-control"
                                name="meta_desc_ar"
                                id="meta_desc_ar"
                                placeholder="Meta Description: Arabic"
                                onChange={this.handleChange}
                                value={this.state.formData.meta_desc_ar}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-5 col-form-label">H1: English</label>
                            <div className="col-md-7">
                              <input
                                type="text"
                                className="form-control"
                                name="h1_en"
                                id="h1_en"
                                placeholder="H1: English"
                                onChange={this.handleChange}
                                value={this.state.formData.h1_en}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-5 col-form-label">H1: Arabic</label>
                            <div className="col-md-7">
                              <input
                                type="text"
                                className="form-control"
                                name="h1_ar"
                                id="h1_ar"
                                placeholder="H1: Arabic"
                                onChange={this.handleChange}
                                value={this.state.formData.h1_ar}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-5 col-form-label">H2: English</label>
                            <div className="col-md-7">
                              <input
                                type="text"
                                className="form-control"
                                name="h2_en"
                                id="h2_en"
                                placeholder="H2: English"
                                onChange={this.handleChange}
                                value={this.state.formData.h2_en}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-5 col-form-label">H2: Arabic</label>
                            <div className="col-md-7">
                              <input
                                type="text"
                                className="form-control"
                                name="h2_ar"
                                id="h2_ar"
                                placeholder="H2: Arabic"
                                onChange={this.handleChange}
                                value={this.state.formData.h2_ar}
                              />
                            </div>
                          </div>
                        </div>
                      </CheckPermission>
                      <div className="col-12">
                        <div className="row">
                          <div className="text-right col-6 offset-6">
                            {this.state.is_saving ? (
                              <button
                                className="btn btn-grd-disabled mr-2"
                                disabled
                              >
                                Saving...!
                              </button>
                            ) : (
                              <>
                                <button
                                  onClick={this.onSave}
                                  className="btn hor-grd btn-grd-inverse offset-1"
                                >
                                  <i className="ti-save"></i>
                                  {this.state.action === 'add' ? 'Save' : 'Update'}
                                </button>
                                <button
                                  onClick={this.onClear}
                                  className="btn hor-grd btn-grd-inverse m-l-10"
                                >
                                  Clear
                                </button>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default TripAddEdit
